{
  "slug": "is-iq-genetic",
  "title": "Le QI est-il génétique?",
  "description": "Découvrez comment les gènes et l’environnement contribuent aux différences cognitives et ce que signifie l’hérédité.",
  "summary": "La capacité cognitive est influencée par de nombreuses variantes génétiques et de nombreux facteurs environnementaux, qui interagissent tout au long du développement.",
  "sections": [
    {
      "heading": "De nombreuses influences, pas un seul gène du QI",
      "paragraphs": [
        "Les différences génétiques contribuent à la variation des scores des tests cognitifs, mais il n’existe pas de gène unique qui détermine le QI d’une personne, les effets étant répartis entre de nombreuses variantes, chacune contribuant généralement très peu.",
        "La nutrition, la santé, l’éducation, la sécurité, le stress, les ressources familiales et les possibilités peuvent influer sur la façon dont les compétences cognitives se développent et s’expriment."
      ]
    },
    {
      "heading": "Ce que signifie l'héritabilité",
      "paragraphs": [
        "L’héritabilité est une statistique de population qui décrit la quantité de variation observée associée aux différences génétiques dans des conditions particulières, mais ne dit pas quel pourcentage de l’intelligence d’une personne est génétique.",
        "Un trait peut être héréditaire et réagir aux changements environnementaux, mais les estimations varient selon l'âge, la population et les conditions sociales."
      ]
    },
    {
      "heading": "Évitez les conclusions déterministes",
      "paragraphs": [
        "Un résultat d’ADN ne peut pas fournir une prédiction complète ou définitive de l’avenir cognitif d’un individu, ni les moyennes de groupe ne peuvent déterminer le potentiel d’un individu.",
        "Des environnements favorables, une éducation efficace, des soins de santé et des opportunités restent des éléments importants."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Combien de QI est héréditaire?",
      "answer": "Il n'existe pas de pourcentage unique pour un individu, les estimations de population varient selon l'âge, l'environnement, la population et la méthode d'étude."
    },
    {
      "question": "L'environnement peut-il affecter le QI?",
      "answer": "L’éducation, la santé, la nutrition, le stress, la langue et les occasions peuvent influencer le développement et les résultats aux tests."
    }
  ],
  "related": ["can-iq-change-over-time", "what-is-iq", "iq-vs-intelligence"]
}
